module.exports = __webpack_public_path__ + "static/media/google-analytics-logo.ddd55e67.png";